import { z } from 'zod';

const TraceHeaderSchema: z.ZodType<string> = z.string().min(1);
export const TraceIdSchema: z.ZodType<string> = z.string().regex(/^[0-9a-f]{32}$/i);

export type TraceContextErrorLogger = (message: string) => void;

export function parseTraceIdFromHeader(
    headerValue: string | undefined,
    onError: TraceContextErrorLogger
): string | null {
    if (headerValue === undefined) {
        return null;
    }
    const headerParseResult = TraceHeaderSchema.safeParse(headerValue);
    if (!headerParseResult.success) {
        onError(`Invalid X-Cloud-Trace-Context header: ${headerValue}`);
        return null;
    }
    const tracePart: string = headerParseResult.data.split(';')[0] ?? '';
    const traceIdCandidate: string = tracePart.split('/')[0] ?? '';
    const traceIdParseResult = TraceIdSchema.safeParse(traceIdCandidate);
    if (!traceIdParseResult.success) {
        onError(`Invalid trace id in X-Cloud-Trace-Context header: ${headerValue}`);
        return null;
    }
    return traceIdParseResult.data.toLowerCase();
}
